/**
 * Implements Trades Saga
 * Main idea is to fetch trades each time new block mined for ETH
 */
import { takeLatest, put, call } from 'redux-saga/effects';
import { actionSetNews, GET_NEWS } from '../actions/news';

import {} from '../actions/rates';
import { KattanaAPI } from '../store/createStore';

function* onGetNews(action: any): any {
  try {
    const controller = new AbortController();
    const data: any = yield call(KattanaAPI.announcements, controller);
    yield put(actionSetNews(data));
  } catch (err) {
    yield put(actionSetNews([]));
    console.error(err);
  }
}

export default function* ratesSaga() {
  yield takeLatest(GET_NEWS, onGetNews);
}
